<div class="m-a-1">
    <router-outlet></router-outlet>
  </div>
  <app-spinner></app-spinner>